import script from "./loadingIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./loadingIcon.vue?vue&type=script&setup=true&lang=js"

import "./loadingIcon.vue?vue&type=style&index=0&id=ae8d4b38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae8d4b38"]])

export default __exports__